import React from 'react'
import styled from '@emotion/styled'

export const SlimTemplate = styled.section`
  max-width: 460px;
  margin: 0 auto;
`
